<template>
    <Button
        size="xl"
        color="white-08"
        leftIcon="android-store"
        interfaceTarget="google_play_button"
        :externalTo="props.url"
        target="_blank"
        :class="$style.google_play_button_override"
        @click="emit('click')"
    >
        <span :class="$style.badge">
            <span :class="$style.get_it_on">GET IT ON</span>
            <span :class="$style.store">Google Play</span>
        </span>
    </Button>
</template>

<script lang="ts" setup>
import Button from '@/components/Buttons/Button.vue'

const emit = defineEmits<{
    click: []
}>()

const props = defineProps<{
    url: string
}>()
</script>
<style module>
.google_play_button_override {
    container-type: inline-size;
    height: 64px;
    overflow: hidden;
    --border-color: var(--white-08);
}

.google_play_button_override:focus-visible {
    --border-color: var(--focus-accent);
}

.google_play_button_override > div {
    gap: 0.5em;
    font-size: 20px;
}

@supports (font-size: 1cqw) {
    .google_play_button_override > div {
        font-size: clamp(11px, 13cqi, 20px);
    }
}

.google_play_button_override svg {
    width: 1.4em;
    height: 1.4em;
    flex-shrink: 0;
}

@media (--tablet-plus) {
    .google_play_button_override svg {
        width: 1.5em;
        height: 1.5em;
    }
}

.badge {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    gap: 0.2em;
    min-width: 0;
}

.get_it_on,
.store {
    line-height: 1;
    letter-spacing: 0.02em;
    white-space: nowrap;
}

.get_it_on {
    font-size: max(0.5em, 8px);
    font-weight: var(--font-weight-accent);
}

.store {
    font-weight: var(--font-weight-semibold);
}
</style>
